/*
 * @Description: 浏览器列表
 * @Author: cxhn429
 * @Date: 2018-12-12 16:19:46
 * @LastEditors: zhongshanxian01
 * @LastEditTime: 2021-08-03 15:51:11
 */

import { isBrowser } from '@config/env';

/**
 * @description 获取浏览器列表
 * @returns object
 */
export function getBrowerList() {
    if (!isBrowser) return {};
    const ua = window.navigator.userAgent;
    const appVersion = window.navigator.appVersion;
    return {
        Ie: !!window.ActiveXObject || 'ActiveXObject' in window, // 包括ie11，之所以不用document.all,是因为ie11假装不支持document.all，返回的是false
        Ie6: !!document.all && !window.XMLHttpRequest,
        Ie7: !!document.all && /msie 7.0/gi.test(appVersion),
        Ie8: !!document.all && /msie 8.0/gi.test(appVersion),
        Ie9: !!document.all && /msie 9.0/gi.test(appVersion),
        Ie10: !!document.all && /msie 10.0/gi.test(appVersion),
        Ie11: /Trident\/7/gi.test(ua),
        Edge: /Edge/gi.test(ua),
        FF: /firefox/gi.test(ua),
        Opera: /opera/gi.test(ua),
        Chrome: /Safari/gi.test(ua) && /Chrome/gi.test(ua) && ua.split('/').length === 5,
        // 遨游
        Maxthon: /Maxthon/gi.test(ua),
        Ipad: /ipad/gi.test(ua),
        '2345': /2345Explorer/gi.test(ua),
        Souguo: /MetaSr/gi.test(ua),
        UC: /UBrowser/gi.test(ua),
        LieBao: /LBBROWSER/gi.test(ua),
        TheWorld: /TheWorld/gi.test(ua),
        QQ: /QQ/gi.test(ua),
        '360': /360/gi.test(ua) || /QihooBrowser/gi.test(ua),
        Baidu: ua.indexOf('Baidu') > -1 || ua.indexOf('BIDUBrowser') > -1,
        Safari: /Safari/gi.test(ua) && !/Chrome/gi.test(ua),
        // 安卓
        isAndroid: /android/gi.test(ua) && !/Linux/gi.test(ua),
        // ios
        isIOS: /\(i[^;]+;( u;)? cpu.+mac os x/gi.test(ua),
        // 微博
        isWeibo: /weibo/gi.test(ua),
        // 微信
        isWx: /MicroMessenger/gi.test(ua),
        // 易信
        isYixin: /yixin/gi.test(ua),
        // 我的世界
        isMC: /MineCraft/gi.test(ua)
    };
}

//ie浏览器且小于ie10
export function lessthanIe10() {
    let browserList = getBrowerList();
    if (browserList.Ie) {
        if (browserList.Ie6 || browserList.Ie7 || browserList.Ie8 || browserList.Ie9) {
            return true;
        }
    }
    return false;
}

//ie浏览器且小于ie11
export function lessthanIe11() {
    let browserList = getBrowerList();
    if (browserList.Ie) {
        if (
            browserList.Ie6 ||
            browserList.Ie7 ||
            browserList.Ie8 ||
            browserList.Ie9 ||
            browserList.Ie10
        ) {
            return true;
        }
    }
    return false;
}

/**
 * @description: 是否我的世界app
 * @return {boolean}
 */
export function isMC() {
    let browserList = getBrowerList();
    return browserList.isMC;
}
